import {
  count,
  dates,
  dollars,
  eventWindow,
  moneyComparison,
  noValues,
  optionalSelection,
  pastWindows,
  selection,
  type SourceCategory,
} from "./crmFilterTaxonomy.vocabulary";
/**
 * v1.5 Billing rows, excluding Accepted invites not linked (DEC-05-R).
 * Never infer data availability from this inventory.
 */
export const CRM_TAXONOMY_BILLING_CATEGORIES = [
  {
    id: "billing_payment",
    number: 15,
    label: "Billing & payment",
    fields: [
      ["payment", "Payment", ["Has failed", "Has succeeded"], noValues],
      [
        "payment_status",
        "Payment status",
        selection,
        ["Active", "Failed", "In retry", "Recovered"],
      ],
      ["payment_recovered_date", "Payment recovered date", dates, pastWindows],
      [
        "plan",
        "Plan",
        [
          "Is",
          "Is not",
          "Is any of",
          "Has changed to",
          "Has upgraded",
          "Has downgraded",
        ],
        ["Live plan list from the Stripe connection"],
      ],
      [
        "billing_interval",
        "Billing interval",
        ["Is", "Is not"],
        ["Monthly", "Annual", "Lifetime"],
      ],
      ["lifetime_value", "Lifetime value", moneyComparison, dollars],
      [
        "monthly_recurring_revenue",
        "Monthly recurring revenue",
        moneyComparison,
        dollars,
      ],
      [
        "discount_applied",
        "Discount applied",
        optionalSelection,
        ["Live coupon list from the Stripe connection"],
      ],
      ["refund", "Refund", eventWindow, noValues],
      [
        "churn_reason",
        "Churn reason",
        selection,
        [
          "Too expensive",
          "Not using it enough",
          "Missing something I needed",
          "Too hard to use",
          "Found another tool",
          "My accountant handles it now",
          "Business closed or sold",
          "Only ever trialling it",
          "Something else",
          "Failed payment",
          "Not given",
        ],
      ],
      ["trial_started_date", "Trial started date", dates, pastWindows],
      [
        "trial_ending_date",
        "Trial ending date",
        dates,
        [
          "Last 48 hours",
          "Last 7 days",
          "Last 30 days",
          "Last 60 days",
          "Last 90 days",
          "Next 7 days",
          "Next 30 days",
        ],
      ],
      [
        "next_renewal_date",
        "Next renewal date",
        dates,
        [
          "Last 48 hours",
          "Last 7 days",
          "Last 30 days",
          "Next 7 days",
          "Next 30 days",
          "Next 90 days",
        ],
      ],
      ["cancelled_date", "Cancelled date", dates, pastWindows],
      ["churned_date", "Churned date", dates, pastWindows],
      ["remaining_seats", "Remaining seats", count, noValues],
      ["connections_purchased", "Connections purchased", count, noValues],
      ["connections_used", "Connections used", count, noValues],
      ["invites_pending", "Invites pending", count, noValues],
      [
        "linked_client_organisations",
        "Linked client organisations",
        count,
        noValues,
      ],
    ],
  },
] as const satisfies readonly SourceCategory[];
